import { categories } from '@/mocks/categories';

export default function TrendingSection() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12 md:mb-16">
          <div>
            <span className="text-xs font-label text-foreground-400 uppercase tracking-[0.2em]">Trending</span>
            <h2 className="text-2xl md:text-4xl font-heading font-semibold italic text-secondary-500 mt-1">
              Подборки 2026
            </h2>
          </div>
          <p className="text-sm md:text-base text-foreground-600 max-w-md leading-relaxed">
            Самые популярные категории товаров этого сезона. Откройте для себя лучшие предложения через YOYBUY Spreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <a
            href="https://kaspreadsheet.com/category-911-Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-accent-300 transition-all duration-300"
            data-product-shop
          >
            <div className="aspect-[3/2] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stylish%20designer%20sneakers%20and%20casual%20shoes%20displayed%20on%20minimal%20cream%20surface%20with%20gentle%20lighting%20modern%20fashion%20editorial%20style%20soft%20shadows%20clean%20composition%20European%20aesthetic%20warm%20neutral%20tones&width=600&height=400&seq=yoybuy-trend-05&orientation=landscape"
                alt="Кроссовки и кеды"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 md:p-6">
              <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-label rounded-full mb-3">
                {categories[0].name}
              </span>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 leading-snug mb-2">
                Кроссовки и кеды
              </h3>
              <span className="inline-flex items-center gap-1 text-xs font-medium text-accent-600 group-hover:text-accent-800 whitespace-nowrap">
                Смотреть
                <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-912/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-accent-300 transition-all duration-300"
            data-product-shop
          >
            <div className="aspect-[3/2] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Aesthetic%20oversized%20hoodies%20and%20sweatshirts%20in%20pastel%20neutral%20colors%20folded%20neatly%20on%20light%20linen%20fabric%20background%20soft%20daylight%20minimalist%20editorial%20photography%20clean%20European%20streetwear%20vibe%20warm%20atmosphere&width=600&height=400&seq=yoybuy-trend-06&orientation=landscape"
                alt="Худи и свитшоты"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 md:p-6">
              <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-label rounded-full mb-3">
                {categories[1].name}
              </span>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 leading-snug mb-2">
                Худи и свитшоты
              </h3>
              <span className="inline-flex items-center gap-1 text-xs font-medium text-accent-600 group-hover:text-accent-800 whitespace-nowrap">
                Смотреть
                <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-923/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-accent-300 transition-all duration-300"
            data-product-shop
          >
            <div className="aspect-[3/2] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20perfume%20bottles%20collection%20with%20glass%20flacons%20arranged%20on%20cream%20marble%20surface%20with%20soft%20flower%20petals%20gentle%20natural%20light%20editorial%20beauty%20photography%20luxurious%20minimal%20style%20European%20aesthetic%20warm%20tones&width=600&height=400&seq=yoybuy-trend-07&orientation=landscape"
                alt="Парфюмерия и ароматы"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 md:p-6">
              <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-label rounded-full mb-3">
                {categories[12].name}
              </span>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 leading-snug mb-2">
                Парфюмерия и ароматы
              </h3>
              <span className="inline-flex items-center gap-1 text-xs font-medium text-accent-600 group-hover:text-accent-800 whitespace-nowrap">
                Смотреть
                <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}